import React from 'react';
import PropTypes from 'prop-types';

import './DashboardFilter.scss';
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect';

const propTypes = {
  value: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  values: PropTypes
    .arrayOf(PropTypes.shape())
    .isRequired,
  changeHandler: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

const defaultProps = {
  disabled: false,
};

const DashboardFilter = ({
  value,
  status,
  name,
  values,
  changeHandler,
  disabled,
  label,
}) => (
  <div className="filter-wrapper">
    <div className="filter-label">
      <span>{label}</span>
    </div>
    <div className="filter">
      <CustomMultiSelect
        closeOnSelect
        values={values}
        status={status}
        value={value}
        name={name}
        focusHandler={() => {}}
        changeHandler={changeHandler}
        searchable={false}
        multi={false}
        disabled={disabled}
      />
    </div>
  </div>
);

DashboardFilter.propTypes = propTypes;
DashboardFilter.defaultProps = defaultProps;

export default DashboardFilter;



// WEBPACK FOOTER //
// ./src/components/_molecules/DashboardFilter/DashboardFilter.js